import fi from './fi.json'
import sv from './sv.json'
import en from './en.json'

export const translations = { fi, sv, en }
